import React, { useState, useRef } from 'react';
import { Button, Form, Row, Col, Container } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import { postDatatoServer } from '../../utils/apiBase';
import ContextHelper from '../../ContextHooks/ContextHelper';

const UpdateDoctor = () => {
  const { currentUser } = ContextHelper();
  const [formState, setFormState] = useState({
    details: '',
    signFile: null
  });
  const [fileErrors, setFileErrors] = useState({
    sign: ''
  });

  const signFileRef = useRef(null);

  const validateFile = (file, type) => {
   if (!file) return '';
    
    const allowedTypes = ['image/jpeg'];
    const maxSize = 5 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) return 'Only JPEG images are allowed';
    if (file.size > maxSize) return 'File size should not exceed 5MB';
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const renamedFile = new File([file], `${currentUser?.name || 'user'}_${type}.jpg`, { type: file.type });
      const validationError = validateFile(renamedFile, type);

      if (type === 'sign') {
        if (validationError) {
          setFormState((prev) => ({ ...prev, signFile: null }));
          setFileErrors({ sign: validationError });
          signFileRef.current.value = '';
          toast.error(`${type} image error: ${validationError}`);
        } else {
          setFormState((prev) => ({ ...prev, signFile: renamedFile }));
          setFileErrors({ sign: '' });
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
   if (!formState.details.trim() && !formState.signFile) {
      toast.error('Please fill in at least one field before submitting.');
      return;
    }
  
   const signError = formState.signFile ? validateFile(formState.signFile, 'Sign') : '';
    setFileErrors({ sign: signError });
  
    if (signError) {
      toast.error(`Sign image error: ${signError}`);
      return;
    }
  
    const formData = new FormData();
    formData.append('isToUpdate', true);
    formData.append('details', formState.details);
  
    if (formState.signFile) formData.append('files', formState.signFile);
  
    postDatatoServer({
      end_point: 'user2',
      body: formData,
      call_back: handleResponse,
      props: {
        header: true,
        token: currentUser?.token,
        contentType: 'multipart/form-data',
      },
    });
  };
  

  const handleResponse = (res) => {
    if (res?.response && res?.status === 'success') {
      toast.success('Doctor details updated successfully');
      clearFiles();
      setFormState({ details: '', signFile: null });
    } else {
      toast.error('Failed to update doctor details');
    }
  };

  const clearFiles = () => {
    setFormState((prev) => ({
      ...prev,
      signFile: null
    }));
    if (signFileRef.current) signFileRef.current.value = '';
    setFileErrors({ sign: '' });
  };

  return (
    <section className="bg-white p-4 min-vh-100 d-flex justify-content-center">
      <Container fluid className="px-0">
        <Row className="justify-content-center">
          <Col>
            <h3 className="base-color mb-4">Update Doctor</h3>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={3} md={4} sm={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Doctor Details</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="details"
                      value={formState.details}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={3} md={4} sm={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Doctor Sign Image</Form.Label>
                    <Form.Control
                      ref={signFileRef}
                      type="file"
                      onChange={(e) => handleFileChange(e, 'sign')}
                      accept="image/jpeg"
                      isInvalid={!!fileErrors.sign}
                    />
                    <Form.Control.Feedback type="invalid">{fileErrors.sign}</Form.Control.Feedback>
                    {formState.signFile && <small className="text-muted d-block mt-1">Selected file: {formState.signFile.name}</small>}
                  </Form.Group>
                </Col>
              </Row>

              <Button type="submit" className="base-color-bg login-btn">
                Update
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UpdateDoctor;